import { render, staticRenderFns } from "./areaDistribution.vue?vue&type=template&id=4a55c932&scoped=true&"
import script from "./areaDistribution.vue?vue&type=script&lang=js&"
export * from "./areaDistribution.vue?vue&type=script&lang=js&"
import style0 from "./areaDistribution.vue?vue&type=style&index=0&id=4a55c932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a55c932",
  null
  
)

export default component.exports